import _ from "lodash";
import { useTaxStore } from "../../../_store/taxplanStore";
import { numberWithoutComma } from "../component/VIDrawerDebt.Main";
import TaxHeirachy from "../../../functions/taxFucntion/taxHeirachy";
import {
  TabTwoExpenseCalculation,
  TabTwoSumIncomeCalculation,
} from "../../../functions/taxFucntion/premium/tab2function";
import { calculateTax } from "../../tax_plan/functions";

export const SumtotalInvestEducation = (balanceData) => {
  let addBalance = balanceData?.property_invest_list
    ? balanceData?.property_invest_list
    : [];
  let sumForEducation = 0;

  addBalance?.map((row, index) => {
    {
      /*---------- พันธบัตร/หุ้นกู้ ----------*/
    }
    if (row?.options_property_invest === "property_invest_bond") {
      row?.invest_bond_lists
        ?.sort((a, b) => new Date(b.created) - new Date(a.created))
        ?.map((row, indexCard) => {
          if (row?.target_invest?.value === "property_invest_education") {
            sumForEducation += row?.amount;
          }
        });
    }

    /*---------- หุ้นบุริมสิทธิ ----------*/

    if (row?.options_property_invest === "property_invest_preferred") {
      row?.invest_preferred_lists
        ?.sort((a, b) => new Date(b.created) - new Date(a.created))
        ?.map((row, indexCard) => {
          if (row?.target_invest?.value === "property_invest_education") {
            sumForEducation += row?.amount;
          }
        });
    }

    /*---------- หุ้นสามัญ ----------*/
    if (row?.options_property_invest === "property_invest_normal") {
      row?.invest_normal_lists
        ?.sort((a, b) => new Date(b.created) - new Date(a.created))
        ?.map((row, indexCard) => {
          if (row?.target_invest?.value === "property_invest_education") {
            sumForEducation += row?.amount;
          }
        });
    }

    /*---------- กองทุนรวมตลาดเงิน ----------*/
    if (row?.options_property_invest === "property_invest_market") {
      row?.invest_market_lists
        ?.sort((a, b) => new Date(b.created) - new Date(a.created))
        ?.map((row, indexCard) => {
          if (row?.target_invest?.value === "property_invest_education") {
            sumForEducation += row?.amount;
          }
        });
    }

    /*---------- กองทุนรวมหุ้น ----------*/
    if (row?.options_property_invest === "property_all_invest") {
      row?.all_invest_lists
        ?.sort((a, b) => new Date(b.created) - new Date(a.created))
        ?.map((row, indexCard) => {
          if (row?.target_invest?.value === "property_invest_education") {
            sumForEducation += row?.amount;
          }
        });
    }

    /*---------- กองทุนรวมเพื่อการเลี้ยงชีพ ----------*/
    if (row?.options_property_invest === "property_invest_life") {
      row?.invest_life_lists
        ?.sort((a, b) => new Date(b.created) - new Date(a.created))
        ?.map((row, indexCard) => {
          if (row?.target_invest?.value === "property_invest_education") {
            sumForEducation += row?.amount;
          }
        });
    }

    /*---------- กองทุนรวมผสม ----------*/
    if (row?.options_property_invest === "property_invest_mixed") {
      row?.invest_mixed_lists
        ?.sort((a, b) => new Date(b.created) - new Date(a.created))
        ?.map((row, indexCard) => {
          if (row?.target_invest?.value === "property_invest_education") {
            sumForEducation += row?.amount;
          }
        });
    }

    /*---------- กองทุนสำรองเลี้ยงชีพ ----------*/
    if (row?.options_property_invest === "property_invest_provident_fund") {
      row?.invest_provident_fund_lists
        ?.sort((a, b) => new Date(b.created) - new Date(a.created))
        ?.map((row, indexCard) => {
          if (row?.target_invest?.value === "property_invest_education") {
            sumForEducation += row?.amount;
          }
        });
    }

    /*---------- เงินออมเพื่อวัยเกษียณอื่น ๆ ----------*/
    if (
      row?.options_property_invest ===
      "property_invest_other_retirement_savings"
    ) {
      row?.invest_other_retirement_savings_lists
        ?.sort((a, b) => new Date(b.created) - new Date(a.created))
        ?.map((row, indexCard) => {
          if (row?.target_invest?.value === "property_invest_education") {
            sumForEducation += row?.amount;
          }
        });
    }

    /*---------- ตลาดเงินอื่น ๆ ----------*/
    if (row?.options_property_invest === "property_money_market_other") {
      row?.invest_money_market_other_lists
        ?.sort((a, b) => new Date(b.created) - new Date(a.created))
        ?.map((row, indexCard) => {
          if (row?.target_invest?.value === "property_invest_education") {
            sumForEducation += row?.amount;
          }
        });
    }

    /*---------- ตราสารอนุพันธ์ ----------*/
    if (
      row?.options_property_invest === "property_invest_derivative_instruments"
    ) {
      row?.invest_derivative_instruments_lists
        ?.sort((a, b) => new Date(b.created) - new Date(a.created))
        ?.map((row, indexCard) => {
          if (row?.target_invest?.value === "property_invest_education") {
            sumForEducation += row?.amount;
          }
        });
    }

    /*---------- มูลค่าเงินสดในกรมธรรม์ประกันชีวิต ----------*/
    if (
      row?.options_property_invest === "property_invest_life_insurance_policy"
    ) {
      row?.invest_life_insurance_policy_lists
        ?.sort((a, b) => new Date(b.created) - new Date(a.created))
        ?.map((row, indexCard) => {
          if (row?.target_invest?.value === "property_invest_education") {
            sumForEducation += row?.amount;
          }
        });
    }

    /*---------- สลากออมสิน ----------*/
    if (row?.options_property_invest === "property_aomsin_bond_policy") {
      row?.aomsin_bond_policy_lists
        ?.sort((a, b) => new Date(b.created) - new Date(a.created))
        ?.map((row, indexCard) => {
          if (row?.target_invest?.value === "property_invest_education") {
            sumForEducation += row?.amount;
          }
        });
    }

    /*---------- ตราสารหนี้อื่นๆ ----------*/
    if (row?.options_property_invest === "property_debt_instruments") {
      row?.property_debt_instruments_lists
        ?.sort((a, b) => new Date(b.created) - new Date(a.created))
        ?.map((row, indexCard) => {
          if (row?.target_invest?.value === "property_invest_education") {
            sumForEducation += row?.amount;
          }
        });
    }

    /*---------- อสังหาริมทรัพย์ ----------*/
    if (row?.options_property_invest === "property_invest_real_estate") {
      row?.invest_real_estate_lists
        ?.sort((a, b) => new Date(b.created) - new Date(a.created))
        ?.map((row, indexCard) => {
          if (row?.target_invest?.value === "property_invest_education") {
            sumForEducation += row?.amount;
          }
        });
    }

    /*---------- มูลค่าทองคำ ----------*/
    if (row?.options_property_invest === "property_invest_gold_cost") {
      row?.invest_gold_cost_lists
        ?.sort((a, b) => new Date(b.created) - new Date(a.created))
        ?.map((row, indexCard) => {
          if (row?.target_invest?.value === "property_invest_education") {
            sumForEducation += row?.amount;
          }
        });
    }

    /*---------- หุ้นในส่วนที่เป็นเจ้าของ ----------*/
    if (row?.options_property_invest === "property_invest_owner") {
      row?.invest_owner_lists
        ?.sort((a, b) => new Date(b.created) - new Date(a.created))
        ?.map((row, indexCard) => {
          if (row?.target_invest?.value === "property_invest_education") {
            sumForEducation += row?.amount;
          }
        });
    }

    /*---------- ตราสารทุนอื่นๆ ----------*/
    if (row?.options_property_invest === "property_equity_instruments") {
      row?.invest_equity_instruments_lists
        ?.sort((a, b) => new Date(b.created) - new Date(a.created))
        ?.map((row, indexCard) => {
          if (row?.target_invest?.value === "property_invest_education") {
            sumForEducation += row?.amount;
          }
        });
    }

    /*---------- เงินลงทุนอื่น ๆ ----------*/
    if (row?.options_property_invest === "property_invest_other") {
      row?.invest_other_lists
        ?.sort((a, b) => new Date(b.created) - new Date(a.created))
        ?.map((row, indexCard) => {
          if (row?.target_invest?.value === "property_invest_education") {
            sumForEducation += row?.amount;
          }
        });
    }

    /*---------- ตราสารหนี้ภาครัฐ ----------*/
    if (row?.options_property_invest === "property_invest_goverment") {
      row?.invest_other_lists
        ?.sort((a, b) => new Date(b.created) - new Date(a.created))
        ?.map((row, indexCard) => {
          if (row?.target_invest?.value === "property_invest_education") {
            sumForEducation += row?.amount;
          }
        });
    }

    /*---------- ตราสารหนี้ภาคเอกชน ----------*/
    if (row?.options_property_invest === "property_invest_private") {
      row?.invest_private_lists
        ?.sort((a, b) => new Date(b.created) - new Date(a.created))
        ?.map((row, indexCard) => {
          if (row?.target_invest?.value === "property_invest_education") {
            sumForEducation += row?.amount;
          }
        });
    }

    /*---------- เงินฝาก ----------*/
    if (row?.options_property_invest === "property_invest_deposit") {
      row?.invest_deposit_lists
        ?.sort((a, b) => new Date(b.created) - new Date(a.created))
        ?.map((row, indexCard) => {
          if (row?.target_invest?.value === "property_invest_education") {
            sumForEducation += row?.amount;
          }
        });
    }
  });

  return sumForEducation;
};

export const sumIncome = (taxData, balanceData) => {
  let bonus_Income = numberWithoutComma(
    balanceData?.other_income_list
      ?.filter((item) => item?.option_income_other === "other_bous")
      ?.reduce((total, num) => {
        return total + Number(num?.other_income_peryear || 0);
      }, 0) || 0
  );

  let salary_Income =
    numberWithoutComma(_.get(taxData, "tax_income", 0)) ||
    (balanceData?.sum_salary_peryear + bonus_Income )||
    0;

  let freeLance_Income = Number(
    taxData?.freelance?.tax_income ||
      balanceData?.other_income_list
        ?.filter((item) => item?.option_income_other === "other_commission")
        ?.reduce((total, num) => {
          return total + Number(num?.other_income_peryear || 0);
        }, 0) ||
      0
  );

  let freeJob_Income = taxData?.freeJob?.reduce((total, num) => {
    return total + Number(num?.tax_income || 0);
  }, 0);

  let income_tax_403 = taxData?.tax_403?.reduce((total, num) => {
    return total + Number(num?.tax_income || 0);
  }, 0);

  let income_tax_403_balance = balanceData?.other_income_list
    ?.filter((item) => item?.option_income_other === "copy_right")
    ?.reduce((total, num) => {
      return total + Number(num?.other_income_peryear || 0);
    }, 0);

  let income_tax_405 = taxData?.tax_405?.reduce((total, num) => {
    return total + Number(num?.tax_income || 0);
  }, 0);

  let income_tax_405_balance = balanceData?.other_income_list
    ?.filter((item) => item?.option_income_other === "other_rent_nonviolence")
    ?.reduce((total, num) => {
      return total + Number(num?.other_income_peryear || 0);
    }, 0);

  let income_tax_406_balance = balanceData?.other_income_list
    ?.filter((item) => item?.option_income_other === "special_profession")
    ?.reduce((total, num) => {
      return total + Number(num?.other_income_peryear || 0);
    }, 0);

  let income_tax_407 = taxData?.tax_407?.reduce((total, num) => {
    return total + Number(num?.tax_income || 0);
  }, 0);

  let income_tax_407_balance = balanceData?.other_income_list
    ?.filter((item) => item?.option_income_other === "contract_business")
    ?.reduce((total, num) => {
      return total + Number(num?.other_income_peryear || 0);
    }, 0);

  let income_tax_408 = taxData?.tax_408?.reduce((total, num) => {
    return total + Number(num?.tax_income || 0);
  }, 0);

  let income_tax_408_balance = balanceData?.other_income_list
    ?.filter((item) => {
      return item?.option_income_other === "other_income_other";
    })
    ?.reduce((total, num) => {
      return total + Number(num?.other_income_peryear || 0);
    }, 0);

  let income_tax_404 = taxData?.tax_404?.reduce((total, num) => {
    return total + Number(num?.tax_income || 0);
  }, 0);

  let income_tax_404_balance = balanceData?.interest_peryear_list?.reduce(
    (total, num) => {
      return total + Number(num?.interest_peryear || 0);
    },
    0
  );

  let income_tax_404_balance_other = balanceData?.other_income_list
    ?.filter((item) => item?.option_income_other === "other_dividend")
    ?.reduce((total, num) => {
      return total + Number(num?.other_income_peryear || 0);
    }, 0);

  // tax_404_stock
  let income_tax_404_stock = taxData?.tax_404_stock?.reduce((total, num) => {
    if (num?.type_job?.label === "หุ้น") {
      return total + Number(num?.dividend || 0) + Number(num?.tax_credit || 0);
    }
    return total + Number(num?.dividend || 0);
  }, 0);

  let income_not_include_tax = _.get(taxData, "income_not_include_tax", 0);

  let RMF_Profit =
    Number(taxData?.RMF_Profit?.selling_price || 0) -
    Number(taxData?.RMF_Profit?.cost_price || 0);
  let SSF_Profit =
    Number(taxData?.SSF_Profit?.selling_price || 0) -
    Number(taxData?.SSF_Profit?.cost_price || 0);

  let Income_42_26 = 0;
  let Income_42_27 = 0;
  let Income_42_28 = 0;

  if (!taxData?.heritage?.tax_calc_include) {
    Income_42_26 = Number(taxData?.heritage?.income_42_26 || 0);
    Income_42_27 = Number(taxData?.heritage?.income_42_27 || 0);
    Income_42_28 = Number(taxData?.heritage?.income_42_28 || 0);
  }

  let tax408_property = taxData?.tax_408_property?.reduce((total, num) => {
    return total + Number(num?.tax_income || 0);
  }, 0);

  let tax408_property_property = balanceData?.other_income_list
    ?.filter((item) => item?.option_income_other === "other_income_selling")
    ?.reduce((total, num) => {
      return total + Number(num?.other_income_peryear || 0);
    }, 0);

  return (
    Number(salary_Income || 0) +
    Number(freeJob_Income || 0) +
    Number(freeLance_Income || 0) +
    Number(income_tax_403 || 0) +
    Number(income_tax_403_balance || 0) +
    Number(income_tax_405 || 0) +
    Number(income_tax_405_balance || 0) +
    Number(income_tax_406_balance || 0) +
    Number(income_tax_407 || 0) +
    Number(income_tax_407_balance || 0) +
    Number(income_tax_408 || 0) +
    Number(income_tax_408_balance || 0) +
    Number(tax408_property_property || 0) +
    Number(income_tax_404 || 0) +
    Number(income_tax_404_balance || 0) +
    Number(income_tax_404_balance_other || 0) +
    Number(income_tax_404_stock || 0) +
    Number(income_not_include_tax || 0) +
    Number(RMF_Profit || 0) +
    Number(SSF_Profit || 0) +
    Number(Income_42_26 || 0) +
    Number(Income_42_27 || 0) +
    Number(Income_42_28 || 0) +
    Number(tax408_property || 0)
  );
};

export const displayDeducExpenses = (taxData) => {
  let sum = 0;
  if (taxData?.tax_income / 2 < 100000) {
    sum = taxData?.tax_income / 2;
    return sum;
  } else return 100000;
};

const getCaltax = (userData, taxData) => {
  const displaySumDeduction = () => {
    let sum = 60000;

    sum += TaxHeirachy(taxData)
      ?.filter((item) => item?.title !== "ผู้มีเงินได้")
      ?.reduce((sum, item) => {
        return sum + Number(item?.value2 || 0);
      }, 0);
    return Number(sum);
  };

  let result = 0;
  result = Number(taxData.tax_income) - 100000 - Number(displaySumDeduction());

  if (userData?.is_premium) {
    result =
      TabTwoSumIncomeCalculation(taxData) -
      TabTwoExpenseCalculation(taxData) -
      Number(displaySumDeduction());
  }

  return calculateTax(result);
};
